// @flow

import React from 'react';

import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import IconButton from 'material-ui/IconButton';
import AddIcon from 'material-ui/svg-icons/content/add';
import ClearIcon from 'material-ui/svg-icons/content/clear';

import Popover from 'material-ui/Popover';

import { staticUrl } from '../../../lib/config';

type Person = {
    id: string;
    firstName: string;
    lastName: string;
    smallAvatar: string;
};

type PropsType = {
    value: Array<Person>;
    source: Array<Person>;
    onChange: ((Array<Person>) => void);
};

type StateType = {
    isPopupOpen: boolean;
    filteredSource: Array<Person>;
    anchorEl: Object;
};

class PersonSelector extends React.Component<PropsType, StateType> {
    constructor(props: PropsType) {
        super(props);

        const valueIds = props.value.map(p => p.id);
        this.state = {
            isPopupOpen: false,
            filteredSource: props.source.filter(p => valueIds.indexOf(p.id) === -1),
            anchorEl: {}
        };
    }

    componentWillReceiveProps(newProps: PropsType) {
        const valueIds = newProps.value.map(p => p.id);
        this.setState({ filteredSource: newProps.source.filter(p => valueIds.indexOf(p.id) === -1) });
    }

    render() {
        return (
            <List>
                <Subheader>Команда</Subheader>
                {this.props.value.map((person, index) => (
                    <ListItem
                        key={index}
                        primaryText={`${person.firstName} ${person.lastName}`}
                        leftAvatar={<Avatar src={`${staticUrl}/${person.smallAvatar}`} />}
                        rightIconButton={(
                            <IconButton
                                onClick={() => this.props.onChange(this.props.value.filter(v => v.id !== person.id))}
                            >
                                <ClearIcon />
                            </IconButton>
                        )}
                    />
                ))}
                <ListItem
                    primaryText="Добавить"
                    leftIcon={<AddIcon />}
                    onClick={event => this.setState({
                        isPopupOpen: true,
                        anchorEl: event.currentTarget,
                    })}
                />
                <Divider />
                <Popover
                    open={this.state.isPopupOpen}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    onRequestClose={() => this.setState({ isPopupOpen: false })}
                >
                    <List>
                        {this.state.filteredSource.map((person, index) => (
                            <ListItem
                                key={index}
                                primaryText={`${person.firstName} ${person.lastName}`}
                                leftAvatar={<Avatar src={`${staticUrl}/${person.smallAvatar}`} />}
                                onClick={() => {
                                    this.props.onChange([].concat(this.props.value, person));
                                    this.setState({ isPopupOpen: false });
                                }}
                            />
                        ))}
                    </List>
                </Popover>
            </List>
        );
    }
}

export default PersonSelector;




// WEBPACK FOOTER //
// src/components/controls/PersonSelector/index.js